import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import { redirect } from "react-router-dom";
import DistrictService from "services/DistrictService";
export const initialState = {
  data: [],
  dataDetail: [],
  dataSelect: [],
  dataDelete: null,
  loading: false,
  error: null,
  hasMore: false,
  status: "idle",
  redirect: false,
};

export const fetchDistrictData = createAsyncThunk(
  "district/fetchDistrictData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText, state } = data;
      const response = await DistrictService.get({
        page,
        pageSize,
        sort,
        searchText,
        state,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const fetchDistrictDataSelect = createAsyncThunk(
  "district/fetchDistrictDataSelect",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText } = data;
      const response = await DistrictService.get({
        page,
        pageSize,
        sort,
        searchText,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchDistrictDetail = createAsyncThunk(
  "district/fetchDistrictDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DistrictService.getById(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const createDistrictData = createAsyncThunk(
  "district/createDistrictData",
  async (data, { rejectWithValue }) => {
    try {
      const { name } = data;
      const response = await DistrictService.createDistrict({
        name,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updateDistrictData = createAsyncThunk(
  "district/updateDistrictData",
  async (data, { rejectWithValue }) => {
    try {
      const { id, name } = data;
      const response = await DistrictService.updateDistrict({
        id,
        name,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const deleteDistrictData = createAsyncThunk(
  "district/deleteDistrictData",
  async (data, { rejectWithValue }) => {
    try {
      const { id, confirm } = data;
      const response = await DistrictService.deleteDistrict(id, confirm);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const districtSlice = createSlice({
  name: "district",
  initialState,
  reducers: {
    resetDataSelectDistrict: (state) => {
      state.dataSelect = [];
    },
    resetDataDeleteDistrict: (state) => {
      state.dataDelete = null;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistrictData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDistrictData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchDistrictData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchDistrictDataSelect.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDistrictDataSelect.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.dataSelect.push(...action.payload.data.data);
        const uniqueData = Array.from(
          new Set(state.dataSelect.map((item) => item.name))
        ).map((name) => {
          return state.dataSelect.find((item) => item.name === name);
        });
        state.dataSelect = uniqueData;
        state.hasMore = action.payload.data.next_page_url;
      })
      .addCase(fetchDistrictDataSelect.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchDistrictDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDistrictDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        state.error = null;
      })
      .addCase(fetchDistrictDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createDistrictData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(createDistrictData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(createDistrictData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateDistrictData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDistrictData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(updateDistrictData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteDistrictData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(deleteDistrictData.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === 200) state.dataDelete = action.payload;
        else {
          state.redirect = true;
          notification.success({ message: "Proses Berhasil" });
        }
      })
      .addCase(deleteDistrictData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetDataSelectDistrict, resetDataDeleteDistrict, showLoading } =
  districtSlice.actions;

export default districtSlice.reducer;
